import { useNavigate, useSearchParams } from 'react-router-dom';
import { Section } from '../../components/ndf/ui/Champ';
import { FormulaireDemande } from '../../components/conges/FormulaireDemande';

/**
 * Poser une absence, en page pleine.
 *
 * L'une des deux portes d'entrée du même formulaire : celle de qui part de son
 * besoin (« je veux poser des congés ») plutôt que de ses dates. L'autre est le
 * calendrier, qui l'ouvre sous le mois avec les dates déjà remplies.
 */
export function CongesDemandePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  return (
    <div className="mx-auto max-w-2xl space-y-4 p-4 md:p-6">
      <header>
        <h1 className="font-titre text-xl font-bold text-nuit">Poser une absence</h1>
      </header>

      <Section titre="Votre demande" teinte="ciel">
        <FormulaireDemande
          initial={{
            debut: params.get('debut') ?? undefined,
            fin: params.get('fin') ?? undefined,
            demi: params.get('demi') ?? undefined,
          }}
          onTermine={(id) => navigate(id ? `/conges/demandes/${id}` : '/conges/demandes')}
          onAnnuler={() => navigate('/conges/mes-conges')}
        />
      </Section>
    </div>
  );
}
